import {
  Badge,
  Button,
  type ButtonProps,
  TooltipBubble,
} from '@carboncopyco/ui';
import type React from 'react';

export interface SidebarButtonProps
  extends Pick<ButtonProps, 'disabled' | 'onClick' | 'icon' | 'aria-label'> {
  tooltipMessage?: string | React.ReactNode;
  selected?: boolean;
  hasBadge?: boolean;
  tooltipWidth?: number;
}

export const SidebarButton = ({
  selected,
  disabled,
  onClick,
  icon,
  tooltipMessage,
  hasBadge,
  tooltipWidth = 54,
  ...props
}: SidebarButtonProps) => {
  return (
    <TooltipBubble
      placement="top"
      title={tooltipMessage}
      interactiveBorder={0}
      width={tooltipWidth}
    >
      <div className="relative">
        <Button
          disabled={disabled}
          icon={icon}
          onClick={onClick}
          link={!selected}
          secondary={!selected}
          lightBlueLink={selected}
          aria-pressed={selected}
          {...props}
        />
        {hasBadge && (
          <div className="absolute -top-1 -right-1.5 pointer-events-none">
            <Badge
              variant={disabled ? 'disabled' : 'dark'}
              label="Beta"
              size="sm"
            />
          </div>
        )}
      </div>
    </TooltipBubble>
  );
};
